import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import CustomSurveyReport from 'components/businesses/tabs/reports/CustomSurveyReport';

import CustomSurveyReportApi from 'apis/reports/CustomSurveyReport';
import SurveyApi from 'apis/Survey';
import CustomSurveyPublicReportConstants from 'constants/Constants';
import CustomSurveyPublicReportModal from 'components/businesses/tabs/reports/CustomSurveyPublicReportModal';

class CustomSurveyPublicReport extends Component {
  constructor() {
    super();
    this.state = {
      customSurveyReport: [],
      startDate: null,
      endDate: null,
      pass_verified: false,
      modal: false,
      password: '',
      heading: { custom_survey_name: '', business_name: '' },
    };

    this.changeReportRange = this.changeReportRange.bind(this);
    this.fetchCustomSurveyReport = this.fetchCustomSurveyReport.bind(this);
  }

  componentDidMount() {
    const { customSurveyId } = this.props.match.params;

    SurveyApi.verifyReportPassword(
      customSurveyId,
      CustomSurveyPublicReportConstants.PASS_PRESENCE
    ).then(({ data }) => {
      if (!data) {
        this.setState({
          pass_verified: true,
        });

        this.fetchCustomSurveyReport();
      } else {
        this.setState({
          modal: !this.state.modal,
        });
      }
    });

    SurveyApi.publicReportHeading(customSurveyId).then(({ data }) => {
      this.setState({
        heading: data,
      });
    });
  }

  onChange = e => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  verifyPassword = e => {
    const { password, modal } = this.state;
    const { customSurveyId } = this.props.match.params;
    e.preventDefault();

    SurveyApi.verifyReportPassword(
      customSurveyId,
      CustomSurveyPublicReportConstants.VERIFY_PASS,
      password
    ).then(({ data }) => {
      if (!data) {
        this.setState({
          pass_verified: false,
        });
        toast.error(() => (
          <div>
            <FontAwesomeIcon icon="exclamation-triangle" />
            Password you entered is incorrect.
          </div>
        ));
      } else {
        this.setState({
          pass_verified: true,
          modal: !modal,
        });
        this.fetchCustomSurveyReport();
      }
    });
  };

  fetchCustomSurveyReport() {
    const { pass_verified } = this.state;
    const { customSurveyId } = this.props.match.params;

    if (pass_verified && customSurveyId) {
      CustomSurveyReportApi.publicGetReport(customSurveyId)
        .then(({ data }) => {
          this.setState({ customSurveyReport: data });
        })
        .catch(e => console.log(e));
    }
  }

  changeReportRange(_startDate, _endDate) {
    const { startDate, endDate } = this.state;

    if ((startDate || endDate) && !_startDate && !_endDate) {
      this.fetchCustomSurveyReport();
    }

    this.setState(
      (state, props) => {
        return {
          startDate,
          endDate,
        };
      },
      () => {
        if (_startDate && _endDate) {
          this.fetchCustomSurveyReport(_startDate.unix(), _endDate.unix());
        }
      }
    );
  }

  render() {
    const { modal, customSurveyReport, startDate, endDate, heading } = this.state;
    const { match } = this.props;
    const { custom_survey_name, business_name } = heading;

    let $initialDisplay = (
      <CustomSurveyReport
        collapseReport={true}
        match={match}
        report={customSurveyReport}
        fetchReport={this.fetchCustomSurveyReport}
        changeReportRange={this.changeReportRange}
        startDate={startDate}
        endDate={endDate}
        isPublic
      />
    );

    return (
      <div className="questions-container">
        <div className="container">
          <Row>
            {modal ? (
              <p />
            ) : (
              <h1 className="public-report-heading">
                {business_name}'s
                <br /> {custom_survey_name} survey
              </h1>
            )}
            <Col xs="12">
              {modal ? (
                <CustomSurveyPublicReportModal
                  modal={modal}
                  onChange={e => this.onChange(e)}
                  verifyPassword={e => this.verifyPassword(e)}
                />
              ) : (
                <div>{$initialDisplay}</div>
              )}
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default withRouter(CustomSurveyPublicReport);



// WEBPACK FOOTER //
// ./src/components/businesses/tabs/reports/CustomSurveyPublicReport.js